import { getConstantValue, getDateString } from "../../core/helper/UtilHelper";
import moment from "moment";

export const getAnimalLogCPColumns = (monthState: any[]) => {
  return [
    {
      title: "No",
      dataIndex: "id",
      key: "id",
      width: 50,
    },
    {
      title: "İşletme",
      dataIndex: "company",
      key: "company",
      render: (value: any) => value.name,
      width: 400,
    },
    {
      title: "Ay",
      dataIndex: "month",
      key: "month",
      width: 70,
      render: (value: any) => getConstantValue(value, monthState),
      filters: monthState,
      // eslint-disable-next-line
      onFilter: (value: any, record: any) => record.month == value,
    },
    {
      title: "Yıl",
      dataIndex: "year",
      key: "year",
      width: 70,
      filters: [
        { text: "2026", value: "2026" },
        { text: "2027", value: "2027" },
        { text: "2028", value: "2028" },
        { text: "2029", value: "2029" },
        { text: "2030", value: "2030" },
      ],
      // eslint-disable-next-line
      onFilter: (value: any, record: any) => record.year == value,
    },
    {
      title: "Oluşturulma Tarihi",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 200,
      render: (value: any) => getDateString(value),
      sorter: {
        compare: (a: any, b: any) =>
          moment(a.createdAt).unix() - moment(b.createdAt).unix(),
      },
    },
  ];
};
